import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'

const state = {}

const getters = {}

const actions = {
  async exportBadgesArchieve ({ commit }, password) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios({
        method: 'get',
        url: api.badge.getBadges(password),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'BadgeList', 'zip')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Badges list was exported!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to export BadgesListing!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/badge-export.js